import React from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router';
import Viewer from 'react-viewer';
import { Document, Page } from 'react-pdf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme) => ({
    button: {
        color: theme.palette.primary.main,
        margin: '0px !important'
    }
}));

export default function PreviewModal({ fileSource, visibleClose, handleModalClose }) {
    // const history = useHistory();
    const classes = useStyles();
    const [visible, setVisible] = React.useState(false);

    const [numPages, setNumPages] = React.useState(null);
    const [pageNumber, setPageNumber] = React.useState(1);
    const [scaleView, setScaleView] = React.useState(1.5);
    const [updateStat, setUpdateStat] = React.useState(false);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }


    const zoomIn = () => {
        setScaleView(scaleView + 0.25)
    };

    const zoomOut = () => {
        if (scaleView >= 1.5) {
            setScaleView(scaleView - 0.25)
        }
    };




    const submitLogout = () => {
        //console.log('history',history)
        // history.push("/login");
    };

    const zoomInImg = () => {
        const myImg = document.getElementById("map");
        const currWidth = myImg.clientWidth;
        const currheight = myImg.clientHeight;
        if (currWidth == 2500) return false;
        else {
            myImg.style.width = (currWidth + 100) + "px";
            myImg.style.height = (currheight + 50) + "px";
        }
    }
    const zoomOutImg = () => {
        const myImg = document.getElementById("map");
        const currWidth = myImg.clientWidth;
        const currheight = myImg.clientHeight;
        //console.log(currWidth)
        if (currWidth <= 400) return false;
        else {
            myImg.style.width = (currWidth - 100) + "px";
            myImg.style.height = (currheight - 50) + "px";

        }
    }

    return (

        <span>
            {/* {fileSource.match(/\.(jpeg|jpg|gif|png|pdf)$/) !== null ? */}
            <Dialog
                onClose={handleModalClose}
                PaperProps={{
                    className: 'QandADailogBox',
                    style: { padding: '20px', minWidth: 'auto', maxWidth: '100%' },
                }}
                aria-labelledby="form-dialog-title"
                open={visibleClose}
            >
                {/* <Viewer
                visible={visibleClose}
                onClose={handleModalClose}
                images={[{ src: fileSource, alt: '' }]}
            /> */}
                {fileSource.match(/\.(jpeg|jpg|gif|png|pdf)$/) !== null ?

                    <span style={{ overflowY: 'scroll' }}>
                        {
                            fileSource.match(/\.(jpeg|jpg|gif|png)$/) !== null ?

                                <div className="modal-image">
                                    <img id="map" src={fileSource} style={{ width: 500, height: 300 }} />
                                </div> :

                                <div>
                                    <Document
                                        file={fileSource}
                                        onLoadSuccess={onDocumentLoadSuccess}
                                    >
                                        {/* <Page pageNumber={pageNumber} scale={scaleView} /> */}
                                        {/* <p>Page {pageNumber} of {numPages}</p> */}
                                        {Array.from(new Array(numPages), (el, index) => (
                                            <Page key={`page_${index + 1}`} pageNumber={index + 1} scale={scaleView} />
                                        ))}
                                    </Document>
                                </div>
                        }
                    </span>
                    :
                    // null
                    <span style={{ marginBottom: '10px' }}>File format not supported for preview</span>
                }

                <DialogActions className="txtCenter" style={{ alignItems: 'center', paddingBottom: '2px !important' }}>
                    {fileSource.match(/\.(jpeg|jpg|gif|png|pdf)$/) === null ?
                        <Button style={{ marginTop: '10px !important' }} className="btnBluepop" onClick={handleModalClose} variant="contained" component="label" color="default">
                            close
                        </Button>
                        // null
                        :
                        <span>
                            <IconButton
                                className={classes.button}
                                aria-label="zoomin"
                                onClick={fileSource.match(/\.(jpeg|jpg|gif|png)$/) !== null ? zoomInImg : zoomIn}
                            >
                                <ZoomInIcon />
                            </IconButton>
                            <IconButton
                                className={classes.button}
                                aria-label="zoomout"
                                onClick={fileSource.match(/\.(jpeg|jpg|gif|png)$/) !== null ? zoomOutImg : zoomOut}
                            >
                                <ZoomOutIcon />
                            </IconButton>
                        </span>
                    }
                </DialogActions>
            </Dialog>
            {/* : null } */}
        </span>
    );
}
